import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UntypedFormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { User } from 'src/app/types/User';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import Swal from 'sweetalert2';
// Removed: import { BusinessEmployeeComponent } from '../business-employee/business-employee.component'; - component should not be imported for injection
import { BusinessFollowerComponent } from '../business-follower/business-follower.component';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-business-followers-request-sent',
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule,
    TruncatePipe,
    CommonSkeletonComponent,
    UserCardComponent,
    NodataFoundComponent,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './business-followers-request-sent.component.html',
  styleUrls: ['./business-followers-request-sent.component.scss']
})
export class BusinessFollowersRequestSentComponent implements OnInit, OnDestroy {
  /** Wireframe list header (title + count, full-width search pill); false = old Bnav header. */
  useWireframeHeader = true;
  // @Input() commonemit
  values: any = {}
  // clickEventsubscription: Subscription;
  // isAdmin
  // isSuperAdmin
  name
  noDatafound: Array<string> = ["No data to display!"];
  // businessId
  // bussinessName
  empSearch: any;
  requestsReceivedData: any;
  userId: any;
  //Usercard initialization;
  userCardConfig: UserCardConfig[] = []
  userCardConfig_requestsent: UserCardConfig[] = []
  showNoDatafound: boolean = false;
  tempvisitorsList: any;
  searchKey

  loadAPIcall:boolean=false;
  requestList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])
  invitepayload =
    {
       limit: 10,
       businessId: null,
       searchAfterKey :null,
       searchContent : null
    }

    loadScroll : boolean = false;
    stopScroll : boolean = false;
    previouseAfterKey : any = null;
    searchSubject = new Subject<string>();
    scrollSubject = new BehaviorSubject<string>(null);
    searchContent: any;
    TotallCount: number = 0;

  constructor(
    // private commonvalues: CommonValues,
    private searchData: SearchData,
    private api: ApiService,
    private util: UtilService,
    // Removed: private employee: BusinessEmployeeComponent - component should not be injected as service
    private router: Router,
    private fb: UntypedFormBuilder,
    private _activate_route: ActivatedRoute
    // Removed: private follower: BusinessFollowerComponent - component should not be injected as service
  ) {
    // this.businessId = route.snapshot.queryParamMap.get('businessId');
    // this.bussinessName = route.snapshot.queryParamMap.get('bussinessName');
    // this.clickEventsubscription = this.commonvalues.getbusinessid().subscribe((res) => {

    //   this.values = res;

    // });

  }
  businessData: any;
  ngOnInit() {
    this._activate_route.queryParams.subscribe(res=>{
      this.businessData = res;
    })
    // this.values = this.commonemit
    // this.isAdmin = localStorage.getItem('isAdmin');
    // this.isSuperAdmin = localStorage.getItem('isSuperAdmin');
    this.userId = localStorage.getItem('userId');

    // if (this.isSuperAdmin) {
    //   this.isAdmin = this.isSuperAdmin
    // }
    this.getVisitorsList()

    // Creating a 'Cancel Invitation' card by Naaz
    this.userCardConfig = []
    // let invite_sent: UserCardConfig = new UserCardConfig("Pending Acceptance", this.inviteSent, this.canShow, true);
    let cancel_invite: UserCardConfig = new UserCardConfig("Cancel Invitation", this.cancelInvitation, this.canShow, true);
    cancel_invite.source = this;
    // invite_sent.source = this;
    // this.userCardConfig.push(invite_sent);
    this.userCardConfig.push(cancel_invite);



    // let removeBtn : UserCardConfig = new UserCardConfig("Remove", this.rejectFollower, this.canShow, true);
    // removeBtn.source = this;
    // this.userCardConfig.push(removeBtn);

    // let ignore : UserCardConfig = new UserCardConfig("Ignore", this.ignoreFollower, this.canShow, true);
    // ignore.source = this;
    // this.userCardConfig.push(ignore);

    this.searchSubject.pipe(
              debounceTime(500),
              distinctUntilChanged()
            ).subscribe(res=>{
              this.loadScroll = false;
              this.resetPayload();
              this. invitepayload.searchContent = res;
              this.requestList.next([]);
              this.getVisitorsList();
              // this.updateSearch();
            });
     this.scrollSubject.pipe(
                   debounceTime(100),
                   distinctUntilChanged()
                 ).subscribe(res=>{
                   if(res!=null){
                     this. invitepayload.searchAfterKey = this.previouseAfterKey;
                     this.getVisitorsList();
                   }
                 })
  }

  ngOnDestroy(): void {
    // if (this.clickEventsubscription) {
    //   this.clickEventsubscription.unsubscribe();
    // }
    this.searchSubject.complete();
    this.scrollSubject.complete();
  }

  resetPayload(){
    this.requestList.next([]);
    this.invitepayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;

  }
  keyupdata(event) {
    if (event.target.value.length == 0) {
      this.onsearch('');
    }
  }
  onsearch(val) {
    if (val != undefined) {
      val = val.trim().toLowerCase();
    }
    this.visitorsList = this.tempvisitorsList
    this.visitorsList = this.filterByString(this.visitorsList, val);
    if (this.visitorsList.length == 0) {
      this.showNoDatafound = true;
    } else {
      this.showNoDatafound = false;
    }

  }

  filterByString(data, s) {
    return data.filter(e => e.userName.toLowerCase().includes(s))
      .sort((a, b) => a.userName.toLowerCase().includes(s) && !b.userName.toLowerCase().includes(s) ? -1 : b.userName.toLowerCase().includes(s) && !a.userName.toLowerCase().includes(s) ? 1 : 0);
  }
  acceptFollower(user: User) {
    let data: any = {}
    data.businessId = this.businessData.businessId
    data.userId = user.userId
    // /business/employee/request/accept - accept employee from request - {'userId': '', 'businessId': ''}
    this.api.create('business/follow/accept/request', data).subscribe(res => {
      if (res.code == '00000') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Follower Added',
          text: 'Follower added successfully',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.getVisitorsList()
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        })
      }

    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while accepting request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }

  //   /business/visitor/all/{businessId}  - Get all visited user - GET
  // /business/visitor/send/all/request/{businessId} - Send request to all visited user - GET
  // /business/visitor/send/request - Send request to particular user - {'userId': '', 'businessId': ''} - POST
  // /business/follow/accept/request - accept request - {'userId': '', 'businessId': ''} - POST
  // /business/follow/reject/request - reject request - {'userId': '', 'businessId': ''} - POST
  inviteFollower(user: User) {
    let data: any = {}
    data.businessId = this.businessData.businessId
    data.userId = user.userId
    this.util.startLoader();
    // /business/employee/request/accept - accept employee from request - {'userId': '', 'businessId': ''}
    this.api.create('business/visitor/send/request', data).subscribe(res => {
      this.util.stopLoader();
      if (res.code == '00000') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Invite sent successfully',
          // text: 'Follower added successfully',
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
      this.getVisitorsList()
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while inviting. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }
  cancelInvitation(user: User) {
    var data: any = {}
    data.userId = user.userId
    data.businessId = localStorage.getItem('businessId')

    this.api.create('business/visitor/invite/cancel', data).subscribe(res => {
      if (res.code == '00000') {
        this.resetPayload();
        this.getVisitorsList()

        // this.visitorsList.splice(this.visitorsList.findIndex(a => a.userId === user.userId), 1)

      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while cancelling invitation. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }

  inviteSent(): void {

  }

  canShow(data, source): boolean {
    return true;
  }

  visitorsList: any = []
  tempList: any = []
  followerList
  getVisitorsList() {
    this.loadAPIcall = true;
    this.visitorsList = []
    this.tempList = []
    this.showNoDatafound = false;
    this.invitepayload.businessId = this. businessData?.businessId || null;
    this.util.startLoader()
    // setTimeout(() => {
      this.api.create('business/invitesendrequests' , this.invitepayload).subscribe(res => {
        this.util.stopLoader()
        this.loadAPIcall = false;
        this.loadScroll = false;

        if(res.code === GigsumoConstants.SUCESSCODE){

          const data = res.data.requestList;
          const searchAfterKey = res.data.searchAfterKey;

          if((data && data.length === 0) || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfterKey)){
            this.stopScroll = true;
          }
          const current =res.data.requestList;
          const exist = this.requestList.getValue();

          const combined = [...exist , ...current];

          this.requestList.next(combined);

          this.previouseAfterKey = searchAfterKey;

          this.tempList = this.requestList.getValue();


          if(res.data.TotallCount !== undefined){
            this.TotallCount = res.data.TotallCount;
          }



        this.showNoDatafound = this.requestList.getValue().length === 0;
           // Checking if data is not empty by Naaz
        if (data && data.lenght != 0) {
          this.tempList = data;

          this.tempList.forEach((element, i) => {
            // if(element.status=="PENDING"){
            //    this.userCardConfig=[]
            //    let invite : UserCardConfig = new UserCardConfig("Invite", this.inviteFollower, this.canShow, true);
            //    invite.source = this;
            //    this.userCardConfig.push(invite);
            //  }
            //  else if(element.status=="REQUEST_SENT"){
            //   element.userName = element.firstName + " " + element.lastName;
            //   invite_sent.source = this;
            //   element.userCardConfig= this.userCardConfig;
            // }

          });
          // this.setBusinessFollowersRequestSent(this.visitorsList)
        }
        }


      }, err => {
        this.util.stopLoader();
      })

      // let data: any = {};
      // data.businessId = this.values.businessId
      // this.api.create('business/followers', data ).subscribe(res => {
      //   this.util.stopLoader()
      //   this.followerList = res;
      //   if(res!=null && res.lenght!=0){
      //     this.followerList = this.sort_by_key(res,"firstName");
      //     this.followerList.forEach((element,i) => {
      //       // if(element.userId==localStorage.getItem("userId")){
      //       //  var b = this.values.followerList[i];
      //       //  this.values.followerList[i] =   this.values.followerList[0];
      //       //  this.values.followerList[0] = b;
      //       // }
      //     });
      //   }

      // })
    // }, 600);

    this.util.stopLoader()
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  userprofile(data) {
    var userData: any = {}
    userData.userId = data
    this.router.navigate(['personalProfile'], { queryParams: userData })
  }

  setBusinessFollowersRequestSent(userdata) {
    this.values.menu = 'followerRequestsSent'
    this.values.followerRequestsSent = userdata
    this.values.followerRequestsSent = this.sort_by_key(userdata, "firstName");
    this.values.followerRequestsSent.forEach((element, i) => {
      if (element.userId == localStorage.getItem("userId")) {
        var b = this.values.followerRequestsSent[i];
        this.values.followerRequestsSent[i] = this.values.followerRequestsSent[0];
        this.values.followerRequestsSent[0] = b;
      }

    });


    // this.commonvalues.businessid(this.values)
  }

  // updateSearch() {
  //   this.invitepayload.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
  //   this.invitepayload.searchAfterKey = null;
  //   this.stopScroll = false;
  //   this.TotallCount=0
  //   this.requestList.next([]);
  //    this.getVisitorsList();
  // }

  onSearchinvite(val : string){
    this.searchSubject.next(val);
     // Setting TotallCount to 0 if visitorsList is empty, otherwise assigning its length by Naaz
    if (!this.visitorsList || this.visitorsList.length === 0) {
      this.TotallCount = 0;
    } else {
      this.TotallCount = this.visitorsList.length;
    }
  }

  onScrollDown(){
    if(!this.stopScroll){
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }

}

